import {useMap} from 'react-leaflet';

const HideAttributeControl = () => {
  const map = useMap();
  map.attributionControl.setPrefix('');
  return null;
};

export default HideAttributeControl;
